<template>
  <v-container>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.required, rules.min, rules.max]"
            :label="$t('DeviceTypes.name')"
            hint="Between 3 and 30 characters"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea v-model="description" auto-grow rows="1">
            <template v-slot:label>
              <div>
                {{$t('DeviceTypes.description')}}
                <small>{{$t('DeviceTypes.optionnal')}}</small>
              </div>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <save-buttons
      :deviceTypeToCreate="deviceTypeToCreate"
      :path="path"
      @back="$emit('back')"
      @error="error"
      @saved="saved"
    ></save-buttons>
  </v-container>
</template>

<script>
import SaveButtonsComponent from "./SaveButtons.vue";

export default {
  components: {
    "save-buttons": SaveButtonsComponent
  },
  props: {
    path: String
  },
  data() {
    return {
      name: "",
      description: "",
      valid: false,
      rules: {
        required: value => !!value || this.$t("DeviceTypes.rules.required"),
        min: v => v.length >= 3 || this.$t("DeviceTypes.rules.min"),
        max: v => v.length <= 30 || this.$t("DeviceTypes.rules.max")
      }
    };
  },
  computed: {
    deviceTypeToCreate: function() {
      let json = {
        name: this.name,
        valid: this.valid
      };
      if (this.description != "") json.description = this.description;
      return json;
    }
  },
  methods: {
    error: function(value) {
      this.$emit("error", value);
    },
    saved: function(value) {
      this.$emit("saved", value);
    }
  }
};
</script>